import { T } from 'ramda';
import { connect } from 'react-redux';

import EditButton from '@/components/ActionButtons/Edit';
import { getBrandEditUrl } from '@/features/brandsPage/selectors';

const mapStateToProps = (state, { itemId }) => ({
  editPageUrl: getBrandEditUrl(state, itemId),
  permission: T,
});

export default connect(mapStateToProps)(EditButton);
